import { render, staticRenderFns } from "./EnableTwoFactorAuthentication.vue?vue&type=template&id=dfcfbe88"
import script from "@/scripts/component/auth/enableTwoFactorAuthentication.js?vue&type=script&lang=js&external"
export * from "@/scripts/component/auth/enableTwoFactorAuthentication.js?vue&type=script&lang=js&external"
import style0 from "./EnableTwoFactorAuthentication.vue?vue&type=style&index=0&id=dfcfbe88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports